/**
 * Reingreso físico — backend REAL.
 *
 * GET  /api/despacho/reingresos-pendientes?glnId=N
 * POST /api/despacho/reingresos { glnId, stockIds }
 */

import {
  ConfirmarReingresoResponse,
  ReingresosPendientesResponse,
  type ConfirmarReingresoResult,
  type ReingresoPendiente,
} from '@/api/contracts/reingresos';
import { apiFetch } from '@/api/http';

export async function getReingresosPendientes(glnId: string | number): Promise<ReingresoPendiente[]> {
  const data = await apiFetch<unknown>(
    `/despacho/reingresos-pendientes?glnId=${encodeURIComponent(String(Number(glnId)))}`,
    { auth: true },
  );
  return ReingresosPendientesResponse.parse(data).unidades;
}

export async function confirmarReingresos(
  glnId: string | number,
  stockIds: readonly number[],
): Promise<ConfirmarReingresoResult> {
  const data = await apiFetch<unknown>('/despacho/reingresos', {
    method: 'POST',
    body: { glnId: Number(glnId), stockIds },
    auth: true,
  });
  return ConfirmarReingresoResponse.parse(data);
}
